// extracted by mini-css-extract-plugin
export default {"link":"MD-z","disabled":"ND-z"};